import { Component, OnInit, ViewEncapsulation } from '@angular/core'
import { Router } from '@angular/router'
import { AuthenticationService } from '../../theme/shared'

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-logout',
  templateUrl: './logout.component.html'
})
export class LogoutComponent implements OnInit {
  constructor(
    private _router: Router,
    private _authService: AuthenticationService
  ) { }

  public ngOnInit(): void {
    // reset login status
    this._authService.logout().subscribe(() => {
      this._authService.clearCookies()
      this._router.navigate(['/login'])
    })
  }
}
